import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { GetTrackingDetailsRequestDto } from "../../../../core/models/bcLedger/getTrackingDetailsRequestDto";
import { GetTrackingDetailsResponseDto } from "../../../../core/models/bcLedger/getTrackingDetailsResponseDto";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { LoaderService } from "../../../../core/services/loader.service";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { CommonModule } from "@angular/common";
import { PackagingDetailsComponent } from "../packaging-details/packaging-details.component";
import { BcledgerService } from "../../../../core/services/bcledger.service";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";

@Component({
  selector: "jni-freight-details",
  templateUrl: "./freight-details.component.html",
  styleUrls: ["./freight-details.component.scss"],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PackagingDetailsComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    SpinnerComponent,
  ],
})
export class FreightDetailsComponent implements OnInit, OnChanges, OnDestroy {
  freightDetailsParams!: GetTrackingDetailsRequestDto;
  freightDetailFormData!: GetTrackingDetailsResponseDto;
  freightDetailForm!: FormGroup;
  shipDate = "";
  deliveryDate = "";
  showFreightCostPrice = true;
  @Input() trackingNumber = "";
  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() closeEvent = new EventEmitter();
  @Input() isModal = false;

  constructor(
    private _route: ActivatedRoute,
    private _freightDetailsService: BcledgerService,
    private _toastr: JniToastrService,
    private _formBuilder: FormBuilder,
    private _loaderService: LoaderService,
    private _loginService: UserManagementService
  ) {
    this._route.params.subscribe(params => {
      this.freightDetailsParams = { ...params } as GetTrackingDetailsRequestDto;
    });

    this.freightDetailForm = this._formBuilder.group({
      freightDetail: this._formBuilder.group({
        freightNumber: [{ value: "", disabled: true }],
        freightCostPrice: [{ value: "", disabled: true }],
        shipStatus: [{ value: "", disabled: true }],
        shippingMethod: [{ value: "", disabled: true }],
        trackingNumber: [
          {
            value: this.freightDetailsParams.FreightTrackingNumber,
            disabled: true,
          },
        ],
        shipDate: [{ value: "", disabled: true }],
        deliveryDate: [{ value: "", disabled: true }],
        pODName: [{ value: "", disabled: true }],
        jNIReference2: [{ value: "", disabled: true }],
        jNIReference3: [{ value: "", disabled: true }],
        jNIReference4: [{ value: "", disabled: true }],
        jNIReference5: [{ value: "", disabled: true }],
        hundredWeightTrackingNumber: [{ value: "", disabled: true }],
        jNIResponsible: [{ value: "", disabled: true }],
        shipperName: [{ value: "", disabled: true }],
        shipperCompany: [{ value: "", disabled: true }],
        shipperAddress: [{ value: "", disabled: true }],
        shipperCity: [{ value: "", disabled: true }],
        shipperCountry: [{ value: "", disabled: true }],
        shipperState: [{ value: "", disabled: true }],
        shipperStreet: [{ value: "", disabled: true }],
        shipperZip: [{ value: "", disabled: true }],
        recipientName: [{ value: "", disabled: true }],
        recipientCompany: [{ value: "", disabled: true }],
        recipientAddress: [{ value: "", disabled: true }],
        recipientCity: [{ value: "", disabled: true }],
        recipientCountry: [{ value: "", disabled: true }],
        recipientState: [{ value: "", disabled: true }],
        recipientStreet: [{ value: "", disabled: true }],
        recipientZip: [{ value: "", disabled: true }],
        recipientPhone: [{ value: "", disabled: true }],
      }),
      packagingDetail: this._formBuilder.group({
        packageType: [{ value: "", disabled: true }],
        packageCount: [{ value: "", disabled: true }],
        weight: [{ value: "", disabled: true }],
        weightUOM: [{ value: "", disabled: true }],
        length: [{ value: "", disabled: true }],
        width: [{ value: "", disabled: true }],
        height: [{ value: "", disabled: true }],
        dimensionUOM: [{ value: "", disabled: true }],
        dimesionWeight: [{ value: "", disabled: true }],
      }),
    });
  }

  ngOnInit(): void {
    this.validateLogin();
    this.getTrackingDetailData();
  }

  ngOnChanges(): void {
    if (this.trackingNumber) {
      this.freightDetailsParams.FreightTrackingNumber = this.trackingNumber;
    }
  }

  validateLogin() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        if (res?.status === "Success" && res?.data?.userRoleId) {
          if (res.data.userRoleId !== UserRole.Admin) {
            this.showFreightCostPrice = false;
          }
        }
      });
  }

  getTrackingDetailData() {
    this._loaderService.setLoaderState(true);
    this._freightDetailsService
      .getTrackingDetailData(this.freightDetailsParams)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.freightDetailFormData = res.data;
            this.patchFreightDetailForm(this.freightDetailFormData);
          } else {
            this._toastr.error("Error", res.message ?? "No results found");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message ?? "No results found");
        },
      });
  }

  patchFreightDetailForm(freightDetailFormData: GetTrackingDetailsResponseDto) {
    this.freightDetailForm.patchValue({
      freightDetail: {
        freightNumber: freightDetailFormData.FreightNumber,
        freightCostPrice: freightDetailFormData.FreightCostPrice,
        shipStatus: freightDetailFormData.ShipStatus,
        shippingMethod: freightDetailFormData.ShippingMethod,
        pODName: freightDetailFormData.PODName,
        jNIReference2: freightDetailFormData.JNIReference2,
        jNIReference3: freightDetailFormData.JNIReference3,
        jNIReference4: freightDetailFormData.JNIReference4,
        jNIReference5: freightDetailFormData.JNIReference5,
        hundredWeightTrackingNumber:
          freightDetailFormData.HundredWeightTrackingNumber,
        jNIResponsible: freightDetailFormData.JNIResponsible,
        shipperName: freightDetailFormData.ShipperName,
        shipperCompany: freightDetailFormData.ShipperCompany,
        shipperAddress: freightDetailFormData.ShipperAddress,
        shipperCity: freightDetailFormData.ShipperCity,
        shipperCountry: freightDetailFormData.ShipperCountry,
        shipperState: freightDetailFormData.ShipperState,
        shipperStreet: freightDetailFormData.ShipperState,
        shipperZip: freightDetailFormData.ShipperZip,
        recipientName: freightDetailFormData.RecipientName,
        recipientCompany: freightDetailFormData.RecipientCompany,
        recipientAddress: freightDetailFormData.RecipientAddress,
        recipientCity: freightDetailFormData.RecipientCity,
        recipientCountry: freightDetailFormData.RecipientCountry,
        recipientState: freightDetailFormData.RecipientState,
        recipientStreet: freightDetailFormData.RecipientState,
        recipientZip: freightDetailFormData.RecipientZip,
        recipientPhone: freightDetailFormData.RecipientPhone,
      },
      packagingDetail: {
        packageType: freightDetailFormData.PackageType,
        packageCount: freightDetailFormData.PackageCount,
        weight: freightDetailFormData.Weight,
        weightUOM: freightDetailFormData.WeightUOM,
        length: freightDetailFormData.Length,
        width: freightDetailFormData.Weight,
        height: freightDetailFormData.Height,
        dimensionUOM: freightDetailFormData.DimensionUOM,
        dimesionWeight: freightDetailFormData.DimesionWeight,
      },
    });
    this.patchShipAndDeliveryDate(freightDetailFormData);
  }

  patchShipAndDeliveryDate(
    freightDetailFormData: GetTrackingDetailsResponseDto
  ) {
    this.shipDate = freightDetailFormData.ShipDate;
    this.deliveryDate = freightDetailFormData.DeliveryDate;
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  closeModal() {
    this.closeEvent.emit();
  }
}
